module.exports = __webpack_public_path__ + "img/hgnn.89113c99.png";